import adSpendMin from './ad_spend-min.png';
import bannerMin from './banner-min.png';
import bgMin from './bg-min.png';
import importMin from './import-min.png';
import sponsorA from './sponsor_1-min.png';
import sponsorB from './sponsor_2-min.png';
import sponsorC from './sponsor_3-min.png';
import sponsorD from './sponsor_4-min.png';
import sponsorE from './sponsor_5-min.png';
import storeIntelligence from './store_intelligence-min.png';

const Images = {
    adSpendMin,
    bannerMin,
    bgMin,
    importMin,
    sponsorA,
    sponsorB,
    sponsorC,
    sponsorD,
    sponsorE,
    storeIntelligence,
}

export default Images;